// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
const API_ENDPOINT = require("./server");

let environment = "DEV"
if (API_ENDPOINT.includes("localhost")) {
    environment = "DEV"
} else if (API_ENDPOINT.includes("dev")) {
    environment = "DEV"
} else if (API_ENDPOINT.includes("uat")) {
    environment = "STAGE"
} else if (API_ENDPOINT.includes("stage")) {
    environment = "STAGE"
} else if (API_ENDPOINT.includes("prod")) {
    environment = "PROD"
} else if (API_ENDPOINT.includes("hwaimiddleware")) {
    environment = "PROD"
} else {
    environment = "DEV"
}

export default environment